import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FaTrash, FaEye, FaTimes, FaEnvelope, FaEnvelopeOpen } from 'react-icons/fa';

export default function AdminQuotes() {
  useAuth();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedQuote, setSelectedQuote] = useState(null);

  useEffect(() => {
    fetchQuotes();
  }, []);

  const fetchQuotes = async () => {
    try {
      const res = await api.get('/quotes');
      setQuotes(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error('Teklif talepleri yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (quote) => {
    setSelectedQuote(quote);
    if (!quote.is_read) {
      try {
        await api.put(`/quotes/${quote.id}/read`);
        setQuotes((prev) =>
          prev.map((q) => (q.id === quote.id ? { ...q, is_read: true } : q))
        );
      } catch (err) {
        // silently fail
      }
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu teklif talebini silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete(`/quotes/${id}`);
      toast.success('Teklif talebi silindi');
      if (selectedQuote?.id === id) {
        setSelectedQuote(null);
      }
      fetchQuotes();
    } catch (err) {
      toast.error('Silme sırasında hata oluştu');
    }
  };

  const unreadCount = quotes.filter((q) => !q.is_read).length;

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) {
    return <div className="admin-loading">Yükleniyor...</div>;
  }

  return (
    <div>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>
            Teklif Talepleri{' '}
            {unreadCount > 0 && <span className="unread-badge">{unreadCount}</span>}
          </h2>
        </div>

        <table className="admin-table">
          <thead>
            <tr>
              <th style={{ width: 30 }}></th>
              <th>Ad Soyad</th>
              <th>Telefon</th>
              <th>E-posta</th>
              <th>Hizmet Turu</th>
              <th>Tarih</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {quotes.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>
                  Henüz teklif talebi yok
                </td>
              </tr>
            ) : (
              quotes.map((quote) => (
                <tr
                  key={quote.id}
                  style={{
                    fontWeight: quote.is_read ? 'normal' : '600',
                    background: quote.is_read ? undefined : 'rgba(134, 205, 145, 0.05)',
                  }}
                >
                  <td>
                    {quote.is_read ? (
                      <FaEnvelopeOpen style={{ color: '#aaa' }} />
                    ) : (
                      <FaEnvelope style={{ color: '#86CD91' }} />
                    )}
                  </td>
                  <td>{quote.name}</td>
                  <td>{quote.phone}</td>
                  <td>{quote.email || '-'}</td>
                  <td>{quote.service_type || '-'}</td>
                  <td>{formatDate(quote.created_at)}</td>
                  <td>
                    <div className="actions">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleView(quote)}
                      >
                        <FaEye />
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(quote.id)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Quote Detail Modal */}
      {selectedQuote && (
        <div className="admin-modal-overlay" onClick={() => setSelectedQuote(null)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Teklif Talebi Detayi</h2>
              <button
                className="admin-modal-close"
                onClick={() => setSelectedQuote(null)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="message-detail">
              <div className="meta">
                <span><strong>Ad Soyad:</strong> {selectedQuote.name}</span>
                <span><strong>Telefon:</strong> {selectedQuote.phone}</span>
                {selectedQuote.email && (
                  <span><strong>E-posta:</strong> {selectedQuote.email}</span>
                )}
                {selectedQuote.service_type && (
                  <span><strong>Hizmet Turu:</strong> {selectedQuote.service_type}</span>
                )}
                <span><strong>Tarih:</strong> {formatDate(selectedQuote.created_at)}</span>
              </div>
              {selectedQuote.message && (
                <div className="body">{selectedQuote.message}</div>
              )}
            </div>
            <div style={{ marginTop: 15, textAlign: 'right' }}>
              <button
                className="btn btn-danger"
                onClick={() => {
                  handleDelete(selectedQuote.id);
                }}
              >
                <FaTrash /> Talebi Sil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
